import { cn } from '@/lib/utils/cn';

interface SpinnerProps {
  className?: string;
  /** Diameter in pixels. */
  size?: number;
  label?: string;
}

/** Accessible loading spinner. */
export function Spinner({ className, size = 18, label = 'Se încarcă…' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        'inline-block animate-spin rounded-full border-2 border-current border-r-transparent border-t-transparent align-[-0.125em]',
        className,
      )}
      style={{ width: size, height: size }}
    />
  );
}
